<customer-wrapper [showBreadcrumb]="false">
  <ng-container main-content>
    <p>Select Customer</p>
    <div class="customer-selection-wrapper">
        <custom-dropdown [items]="customers" [(selectedItem)]="selectedCustomer" [getItemLabel]="getCustomerLabel" />
        <button class="default-custom-button custom-button custom-button-stroked" id="edit" type="submit" (click)="exportUsageData()">
            <div>
                Export
            </div>
        </button>
    </div>
    <section class="usage-headlines">
        <div class="amounts-used-column headline-column">
            <div class="usage-headline-cell">
                <div class="headline-item">
                    <img src="assets/icons/bus.svg">
                    <span>Vehicles Configured</span>
                </div>
                <div class="headline-item">
                    <span>
                        <span class="headline-value">{{selectedCustomer?.assetCount}}</span> of {{selectedCustomer?.subscriptionDetails?.assetLimit}}
                    </span>
                </div>
            </div>
            <div class="usage-headline-cell">
                <div class="headline-item">
                    <img src="assets/icons/database.svg">
                    <span>Current Storage</span>
                </div>
                <div class="headline-item">
                    <span>
                        <span class="headline-value">{{convertBytesToGigabytes(selectedHeadlineStats?.blobStorageUsed)}} GB</span> of {{selectedCustomer?.subscriptionDetails?.storageLimit}} TB
                    </span>
                </div>
            </div>
        </div>
        <div class="subscription-details-column headline-column">
                <div class="usage-headline-cell">
                    <div class="headline-item">
                        Subscription Start Date
                    </div>
                    <div class="headline-item headline-value">
                        {{formatDate(selectedCustomer?.subscriptionStartDate)}}
                    </div>
                </div>
                <div class="usage-headline-cell">
                    <div class="headline-item">
                        Subscription End Date
                    </div>
                    <div class="headline-item headline-value">
                        {{formatDate(selectedCustomer?.subscriptionEndDate)}}
                    </div>
                </div>
        </div>
        <div class="other-details-column headline-column">
                <div class="usage-headline-cell">
                    <div class="headline-item">
                        Tenancy Creation Date
                    </div>
                    <div class="headline-item headline-value">
                        {{formatDate(selectedCustomer?.createdDate)}}
                    </div>
                </div>
                <div class="usage-headline-cell">
                    <div class="headline-item">
                        Current Configured Retention Period
                    </div>
                    <div class="headline-item headline-value">
                        {{retentionPeriodInDays}} days
                    </div>
                </div>
        </div>
    </section>
    <section>
        <header class="usage-section-header">
            <img src="assets/icons/bulletlist.svg" />
            <h1>Incidents</h1>
        </header>
        <div class="usage-section-content incidents-usage-content">
            <div class="incident-cards">
                <count-card
                    [label]="incidentsCreatedMonthlyCard?.label"
                    [count]="incidentsCreatedMonthlyCard?.count"
                    [percentageProgress]="incidentsCreatedMonthlyCard?.percentageProgress"
                    [subtext]="'Current Month'"
                    style="min-width: 250px;"
                ></count-card>
                <count-card
                    [label]="totalIncidentsCard?.label"
                    [count]="totalIncidentsCard?.count"
                ></count-card>
                <count-card
                    [label]="activeIncidentsCard?.label"
                    [count]="activeIncidentsCard?.count"
                ></count-card>
                <count-card
                    [label]="'Deleted or Expired Incidents'"
                    [count]="latestIncidentData?.deletedIncidents"
                ></count-card>
                <count-card
                    [label]="incidentsSharedMonthlyCard?.label"
                    [count]="incidentsSharedMonthlyCard?.count"
                    [percentageProgress]="incidentsSharedMonthlyCard?.percentageProgress"
                    [subtext]="'Current Month'"
                    class="stretch-card"
                ></count-card>
                <count-card
                    [label]="totalIncidentsSharedCard?.label"
                    [count]="totalIncidentsSharedCard?.count"
                    class="stretch-card"
                ></count-card>
            </div>
            <div class="incident-graphs">
                <div class="incident-graph-container usage-chart-container">
                    <incidents-created-chart [tenantId]="selectedCustomer?.tenantId" [initialTenantData]="initialTenantData" />
                </div>
                <div class="incident-graph-container usage-chart-container">
                    <incidents-shared-chart [tenantId]="selectedCustomer?.tenantId" [initialTenantData]="initialTenantData" />
                </div>
            </div>
        </div>
    </section>
    <div class="usage-row">
        <section class="uploads-section" [style.min-width]="'50%'">
            <header class="usage-section-header">
                <img src="assets/icons/progress-upload.svg" />
                <h1>Uploads</h1>
            </header>
            <div class="usage-uploads-grid usage-section-content">
                <div class="upload-statuses-chart-container usage-chart-container">
                    <upload-statuses-chart [customer]="selectedCustomer" [uploadsChartMin]="uploadsChartMin" [uploadsChartMax]="uploadsChartMax" [style.min-width.px]="uploadsChartMin" [style.max-width.px]="uploadsChartMax"/>
                </div>
                <div class="upload-cards">
                    <count-card
                        [label]="retryAttemptsCard?.label"
                        [count]="retryAttemptsCard?.count"
                    ></count-card>
                    <count-card
                        [label]="successfulRetriesCard?.label"
                        [count]="successfulRetriesCard?.count"
                    ></count-card>
                    <count-card
                        [label]="failedRetriesCard?.label"
                        [count]="failedRetriesCard?.count"
                    ></count-card>
                </div>
            </div>
            <header class="usage-section-header">
                <img src="assets/icons/download.svg" />
                <h1>Downloads</h1>
            </header>
            <div class="usage-section-content">
                <div class="usage-chart-container">
                    <downloads-chart [initialTenantData]="initialTenantData" [tenantId]="selectedCustomer?.tenantId"/>
                </div>
            </div>
        </section>
        <section class="streaming-section">
            <header class="usage-section-header">
                <img src="assets/icons/camera.svg" />
                <h1>Live Video Streaming</h1>
            </header>
            <div class="usage-section-content streaming-section-content">
                <div class="streaming-cards">
                    <count-card
                        [label]="yearlyStreamingAllowanceCard?.label"
                        [count]="yearlyStreamingAllowanceCard?.count"
                    ></count-card>
                    <count-card
                        [label]="monthlyStreamingCard?.label"
                        [count]="monthlyStreamingCard?.count"
                    ></count-card>
                </div>
                <div class="graph-container usage-chart-container streaming-graph-container">
                    <streaming-graph [tenantId]="selectedCustomer?.tenantId" [initialTenantData]="initialTenantData" />
                </div>
            </div>
        </section>
    </div>
    <div class="usage-row">
        <section [style.min-width]="'50%'">
            <header class="usage-section-header">
                <img src="assets/icons/seatbelt.svg" />
                <h1>Redaction</h1>
            </header>
            <div class="usage-section-content">
                <div class="redaction-cards">
                    <count-card
                        [label]="monthlyRedactionRequestsCard?.label"
                        [count]="monthlyRedactionRequestsCard?.count"
                    ></count-card>
                    <count-card
                        [label]="monthlyRedactionMinutesCard?.label"
                        [count]="monthlyRedactionMinutesCard?.count"
                    ></count-card>
                    <count-card
                        [label]="monthlyAudioRedactionRequestsCard?.label"
                        [count]="monthlyAudioRedactionRequestsCard?.count"
                    ></count-card>
                </div>
            </div>
            <div class="usage-section-content">
                <div class="graph-container usage-chart-container">
                    <redaction-graph [tenantId]="selectedCustomer?.tenantId" [initialTenantData]="initialTenantData" />
                </div>
            </div>
        </section>
        <section [style.min-width.px]="680">
            <div class="user-header-wrapper">
                <header class="usage-section-header">
                        <img src="assets/icons/account-group-outline.svg" />
                        <h1>Users</h1>
                </header>
                <div>User Groups : {{totalUserGroupCount}}</div>
            </div>
            <div class="usage-chart-container usage-section-content">
                <users-chart [groupedPieData]="usersData" [currentUsersCount]="loggedInUsersCount"/>
            </div>
        </section>
    </div>
  </ng-container>
</customer-wrapper>
